//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import {PublicAppLayout} from 'app_components/layouts/public'
import BannerTextPrimaryCommon from 'app_components/commons/bannertextprimary'
import AllThingsModule from 'app_components/modules/academic/allthings'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../podcastsScreen.scss'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'

// @ADD Component types
interface IPodcastsScreenLayoutProps {}

const PodcastsScreenLayout: React.FC<IPodcastsScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <PublicAppLayout>
      <div className="podcasts-screen--layout">
        <TextComponent type='title' as='h2' textTransform='none'>Podcast</TextComponent>
        <AllThingsModule type={'podcast'}/>
      </div>
    </PublicAppLayout>
  )
}

export default PodcastsScreenLayout
